import { apiClient } from '~/adapters/apiClient';
import { DEFAULT_PAGE_SIZE } from '~/constants/pagination';
import log from '~/logger';
import { fetchUserPreferences } from './userPreferencesService';
export async function fetchProjects(params) {
    try {
        const userPreferences = await fetchUserPreferences();
        const queryParams = {
            projectName: params?.projectName,
            sportActivityId: params?.sportActivityId,
            franchiseId: params?.franchiseId,
            siloId: params?.siloId,
            referenceStyleNumber: params?.referenceStyleNumber,
            page: params?.page,
            count: params?.count ?? DEFAULT_PAGE_SIZE,
            sort: params?.sort,
            brandId: userPreferences.brand,
            divisionId: userPreferences.division,
            fieldOfPlayId: userPreferences.fieldsOfPlay
        };
        return await apiClient.get('/product_planning/projects/v1', 'pulse-projects', queryParams);
    }
    catch (error) {
        log.error('Failed to fetch projects', {
            error: error instanceof Error ? error.message : 'Unknown error',
            params
        });
        return { pages: { totalPages: 0, totalResources: 0 }, objects: [] };
    }
}
export async function fetchProjectById(id) {
    try {
        const data = await apiClient.get(`/product_planning/projects/v1/${id}`, 'pulse-projects');
        return data;
    }
    catch (error) {
        log.error('Failed to fetch project by ID', {
            error: error instanceof Error ? error.message : 'Unknown error',
            projectId: id
        });
        return null;
    }
}
export async function fetchProjectByHandle(handle) {
    try {
        const data = await apiClient.get('/product_planning/projects/v1', 'pulse-projects', { handle });
        return data.objects?.[0] ?? null;
    }
    catch (error) {
        log.error('Failed to fetch project by handle', {
            error: error instanceof Error ? error.message : 'Unknown error',
            handle
        });
        return null;
    }
}
